<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="false"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
  <!-- Google tag (gtag.js) -->
  <!--
  <script async src="https://www.googletagmanager.com/gtag/js?id=G-LWQRV5QS22"></script>
  <script> window.dataLayer = window.dataLayer || [];  function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-LWQRV5QS22'); </script>
  -->
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="profileName"></app-st-header-title>
    </div>
  </div>
  <div *ngIf="showMessages" class="container st-form text-danger" #goUp>
    <app-st-span><b>Please validate the following: </b></app-st-span>
    <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button *ngIf="this.verified" [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSave()"></app-st-button>
    </div>

    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'consultant-email-text-id'"
                           [label]="'*Consultant Email'"
                           [placeHolderVal]="'Consultant Email'"
                           [requiredVal]="true"
                           [maxLength]="40"
        ></app-st-input-text>
      </div>
      <div class="col">
        <app-st-input-text [idVal]="'referral-code-text-id'"
                           [label]="'*Referral Code'"
                           [placeHolderVal]="'Referral Code'"
                           [requiredVal]="true"
                           [maxLength]="50"
        ></app-st-input-text>
      </div>
    </div>
    <br>
    <app-st-button [idVal]="'verify-button-id'" [label]="'Verify'" [primary]="true"
                   (click)="this.verifyConsultantReferralCodeAtRegistration()"></app-st-button>

    <br>
    <br>
    <div *ngIf="!loadingIcon && !this.verified && !this.verifyButtonClicked">
      <app-st-span [inputVal]="'Please verify your consultant email and referral code to load your consultant information.'"></app-st-span>
    </div>
    <br>
    <br>
    <div *ngIf="!loadingIcon && this.verified && this.verifyButtonClicked">
      <app-st-header-title [inputVal]="'Consultant Information'"></app-st-header-title>
      <div class="row pt-2">
        <div class="col">
          <app-st-input-text [idVal]="'first-name-text-id'"
                             [label]="'*First Name'" [inputVal]="savedFirstName"
                             [placeHolderVal]="'First Name'"
                             [requiredVal]="true"
                             [maxLength]="40"
          ></app-st-input-text>
        </div>
        <div class="col">
          <app-st-input-text [idVal]="'last-name-text-id'"
                             [label]="'*Last Name'" [inputVal]="savedLastName"
                             [placeHolderVal]="'Last Name'"
                             [requiredVal]="true"
                             [maxLength]="40"
          ></app-st-input-text>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <app-st-input-text-phone [idVal]="'phone-number-text-id'"
                                   [label]="'*Phone Number: (Format: 1234567890)'" [inputVal]="savedPhoneNumber" [requiredVal]="true" [maxLength]="20"
          ></app-st-input-text-phone>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <app-st-input-text-email [idVal]="'email-text-id'"
                                   [label]="'*Email'" [inputVal]="savedEmail" [requiredVal]="true" [disabled]="true"
                                   [maxLength]="40"
          >
          </app-st-input-text-email>
        </div>
        <div class="col">
          <app-st-input-text-email [idVal]="'confirm-email-text-id'"
                                   [label]="'*Confirm Email'" [inputVal]="savedEmail"  [requiredVal]="true" [disabled]="true"
                                   [maxLength]="40"
          >
          </app-st-input-text-email>
        </div>
      </div>

      <!--
      <div class="row pt-2">
        <div class="col">
          <app-st-input-text [idVal]="'address-line-1-text-id'"
                             [label]="'*Address Line 1'" [inputVal]="savedAddressLine1"
                             [disabled]="false"
                             [maxLength]="100"
          ></app-st-input-text>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <app-st-input-text [idVal]="'address-line-2-text-id'"
                             [label]="'Address Line 2'" [inputVal]="savedAddressLine2"
                             [disabled]="false"
                             [maxLength]="100"
          ></app-st-input-text>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <app-st-input-text [idVal]="'city-text-id'"
                             [label]="'*City'" [inputVal]="savedCity"
                             [disabled]="false"
                             [maxLength]="100"
          ></app-st-input-text>
        </div>
      </div>

      <app-st-span [inputVal]="'*State:'"></app-st-span><br>
      <app-st-select [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.statesList"></app-st-select>

      <div class="row pt-2">
        <div class="col">
          <app-st-input-text [idVal]="'zip-code-text-id'"
                             [label]="'*Zip Code: (Formats: 12345, 123456789, or 12345-6789)'" [inputVal]="savedZipCode"
                             [disabled]="false"
                             [maxLength]="20"
          ></app-st-input-text>
        </div>
      </div>-->

      <div class="row pt-2">
        <div class="col">
          <app-st-input-text [idVal]="'company-name-text-id'"
                             [label]="'*Company Name'" [inputVal]="savedCompanyName"
                             [requiredVal]="true"
          ></app-st-input-text>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <app-st-input-text [idVal]="'job-title-text-id'"
                             [label]="'*Job Title'" [inputVal]="savedJobTitle"
                             [requiredVal]="true"
          ></app-st-input-text>
        </div>
      </div>
      <br>
      <div>
        <br>
        <p class="webtext-black"><b>Password Policy:</b></p>
        <ul class="webtext-black">
          <li>Password must be at least 10 characters.</li>
          <li>Password must contain at least one lowercase letter.</li>
          <li>Password must contain at least one uppercase letter.</li>
          <li>Password must contain at least one number.</li>
        </ul>
      </div>
      <div class="row pt-2">
        <div class="col">
          <app-st-input-sensitive-text [idVal]="'password-text-id'"
                                       [label]="'*Password'" [inputVal]="savedPassword" [requiredVal]="true"></app-st-input-sensitive-text>
        </div>
        <div class="col">
          <app-st-input-sensitive-text [idVal]="'password-repeat-text-id'"
                                       [label]="'*Repeat Password'" [inputVal]="savedPassword" [requiredVal]="true"></app-st-input-sensitive-text>
        </div>
      </div>
      <br>
    </div>
    <br>
    <div>
      <br>
      <p class="webtext-black"><b>Consultant Account Requirements & Access:</b></p>
      <ul class="webtext-black">
        <li><b>Consultant accounts are available by invitation only.</b> Consultants must be invited by an active nonprofit client to register for a consultant account. Once your client sends an invitation, you will receive an email with instructions to create your account.</li>
        <li><b>Early registration requests will be placed in a pending queue.</b> If you complete the registration process before receiving an invitation from a nonprofit client, your account request will remain pending until a client invites you and activates your access.</li>
        <li><b>A valid payment method is required.</b> Consultants must maintain an active credit card on file to keep their account in good standing.</li>
        <li><b>Free access is sponsored by active nonprofit clients.</b> Consultant accounts are provided at no cost while the consultant is connected to at least one nonprofit organization with an active Scalanthropy subscription.</li>
        <li><b>Billing and account status.</b> If a consultant no longer has any active nonprofit clients with valid Scalanthropy subscriptions, the consultant account will automatically convert to a paid monthly subscription and the credit card on file will be charged according to the current consultant pricing plan. Failure to maintain a valid payment method may result in account suspension or deactivation.</li>
      </ul>
    </div>

    <div *ngIf="loadingIcon && !this.verified && this.verifyButtonClicked">
      <div>
        <div class="d-flex justify-content-center">
          <br>
          <br>
          <div class="spinner-grow text-info" role="status">
            <span class="visually-hidden webtext-black">Loading...</span>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row pt-3">
      <div class="col">
        <a id="terms-and-conditions-alink-id" class="terms-conditions-link" href="https://www.scalanthropy.com/terms-conditions" target="_blank">View Terms and Conditions</a>
        <br>
        <div class="form-check">
          <input class="form-check-input radio-button-properties" type="radio" value="true" id="legal-agreement-radio-button-id"
                 (click)="toggleLegalAgreement()" [checked]="termsAndConditionsRadioButton">
          <app-st-span [inputVal]="'I Agree'"></app-st-span>
        </div>
      </div>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <br>
    <div *ngIf="showSuccessMessages" class="container st-messages-form text-success" #goUp>
      <app-st-span><b>Please validate the following: </b></app-st-span>
      <div *ngFor="let successMsg of successMessages" class="alert alert-success" role="alert">
        <b>{{successMsg.field}}:</b> {{successMsg.detail}}
      </div>
      <br>
    </div>
    <div *ngIf="showMessages" class="container st-messages-form text-danger" #goUp>
      <app-st-span><b>Please validate the following: </b></app-st-span>
      <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
        <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
      </div>
      <br>
    </div>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'bottom-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button *ngIf="this.verified" [idVal]="'bottom-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSave()"></app-st-button>
    </div>
    <br>
    <br>
    <br>
  </div>
</div>


